<template>
  <div>
    <div class="bg" />
    <div id="title">הזנת סריאל</div>
    <div id="divider" />
    <form
      novalidate
      class="md-layout md-alignment-center margin-sides"
      @submit.prevent="validateUser"
    >
      <md-card
        class="md-layout-item md-size-50 md-small-size-100"
        style="background:white; direction: rtl;"
      >
        <md-card-header>
          <div class="md-title">פרטי תשלום</div>
        </md-card-header>

        <md-card-content class="pad-sides">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('cardOwnerName')">
                <label for="cardOwnerName">שם בעל הכרטיס</label>
                <md-input
                  name="cardOwnerName"
                  id="cardOwnerName"
                  autocomplete="cardOwnerName"
                  v-model="form.cardOwnerName"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.cardOwnerName.required">שם בעל הכרטיס נדרש</span>
                <span
                  class="md-error"
                  v-else-if="!$v.form.cardOwnerName.minLength"
                >שם בעל הכרטיס אינו תקין</span>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('cardNumber')">
                <label for="cardNumber">מספר כרטיס</label>
                <md-input
                  name="cardNumber"
                  id="cardNumber"
                  autocomplete="cardNumber"
                  v-model="form.cardNumber"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.cardNumber.required">מספר כרטיס אשראי נדרש</span>
                <span
                  class="md-error"
                  v-else-if="!$v.form.cardNumber.minLength || !$v.form.cardNumber.numeric"
                >מספר כרטיס אשראי אינו תקין</span>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('cardExpirationDate')">
                <label for="cardExpirationDate">תאריך תפוגה (mm/yy)</label>
                <md-input
                  name="cardExpirationDate"
                  id="cardExpirationDate"
                  autocomplete="cardExpirationDate"
                  v-model="form.cardExpirationDate"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.cardExpirationDate.required">תאריך תפוגה נדרש</span>
                <span
                  class="md-error"
                  v-else-if="!$v.form.cardExpirationDate.between"
                >תאריך תפוגה אינו תקין - הפורמט הינו (mm/yy)</span>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('cvv')">
                <label for="serial">CVV</label>
                <md-input
                  name="cvv"
                  id="cvv"
                  autocomplete="cvv"
                  v-model="form.cvv"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.cvv.required">קוד cvv נדרש</span>
                <span
                  class="md-error"
                  v-else-if="!$v.form.cvv.between || !$v.form.cvv.numeric"
                >קוד cvv לא תקין</span>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('idNumber')">
                <label for="idNumber">מספר תעודת זהות</label>
                <md-input
                  name="idNumber"
                  id="idNumber"
                  autocomplete="idNumber"
                  v-model="form.idNumber"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.idNumber.required">מספר תעודת זהות נדרשת</span>
                <span
                  class="md-error"
                  v-else-if="!$v.form.idNumber.between || !$v.form.idNumber.numeric"
                >מספר תעודת זהות אינו תקין</span>
              </md-field>
            </div>
          </div>

          <div style="text-align:center; margin-top: 16px; margin-bottom: 8px;">
            <p v-if="amountToPay" class="amount-txt">סכום לתשלום : {{amountToPay}} ₪</p>
          </div>
        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending" />

        <md-card-actions>
          <md-button
            type="submit"
            class="confirm-btn md-primary md-raised"
            :disabled="sending"
          >סיים רכישה</md-button>
        </md-card-actions>


        <md-card-content class="pad-sides" style="text-align:center">
          <div><p style="color: grey">*לא מכבדים כרטיסי דיינרס</p></div>
         <img style="margin-bottom: 12px; height: 5vh;" class="margin-top" src="https://storage.cloud.google.com/tzav-rishon-web-assets/security_images.png" alt="">
         <div><p style="color:black; font-size:20px;">דף התשלום מאובטח בתקן PCI</p></div>
         <img style="height: 5vh;" class="margin-top" src="https://storage.cloud.google.com/tzav-rishon-web-assets/pci.png" alt="">
        </md-card-content>

        
      </md-card>

      <md-snackbar
        :md-active.sync="userSaved"
      >הרכישה הסתיימה בהצלחה, ניתן לחזור למסך האפליקציה אם אינך מועבר אוטומטית</md-snackbar>
      <md-snackbar :md-active.sync="showError">{{this.errorMsg}}</md-snackbar>
    </form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, numeric } from "vuelidate/lib/validators";
import { apiEndpoint, devAppUrl, prodAppUrl } from "../global/config.json";
import { checkIfInMoile, isDebug } from "../helpers/utils";
import axios from "axios";

const exectLength = length => value => value.length === length;

// eslint-disable-next-line
const analytics = firebase.analytics();

export default {
  name: "FormValidation",
  mixins: [validationMixin],
  beforeCreate: () => {
    if (localStorage.pkg === null || this.$cookies.get("token") === null) {
      this.$router.replace("/pacakges");
    }
  },
  data: () => ({
    form: {
      cardOwnerName: null,
      idNumber: null,
      cvv: null,
      cardExpirationDate: null,
      cardNumber: null
    },
    amountToPay: localStorage.getItem("amountToPay"),
    licenseLength: null,
    licenseValidity: null,
    userSaved: false,
    showError: false,
    errorMsg: null,
    sending: false,
    lastUser: null
  }),
  validations: {
    form: {
      cardOwnerName: {
        required,
        minLength: minLength(3)
      },
      idNumber: {
        required,
        numeric,
        between: exectLength(9)
      },
      cvv: {
        required,
        numeric,
        between: exectLength(3)
      },
      cardExpirationDate: {
        required,
        between: exectLength(5)
      },
      cardNumber: {
        required,
        numeric,
        minLength: 16
      }
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    clearForm() {
      this.$v.$reset();
      this.form.serialCode = null;
    },
    saveUser() {
      this.sending = true;

      
      const {
        cardOwnerName,
        idNumber,
        cvv,
        cardExpirationDate,
        cardNumber
      } = this.$data.form;

      analytics.logEvent("add_payment_info");

      const { pkg } = localStorage;
      const token = this.$cookies.get("token");

      axios
        .post(`${apiEndpoint}/checkout`, {
          token,
          pkg,
          idNumber,
          ccno: cardNumber,
          expdate: cardExpirationDate,
          cvv,
          card_holder_name: cardOwnerName
        })
        .then(res => res.data)
        .then(res => {
          if (res.status === "success") {
            this.userSaved = true;
            this.clearForm();

            analytics.logEvent("purchase", {
              currency: "ILS",
              items: [pkg],
              value: Number(this.amountToPay)
            });

            if (!checkIfInMoile()) {
              window.location.href = isDebug() ? devAppUrl : prodAppUrl;
            }
          } else {
            this.errorMsg = res.message || "לא בוצעה רכישה";
            this.showError = true;
          }
        })
        .catch(err => {
          this.errorMsg = err;
        })
        .finally(() => {
          this.sending = false;
        });
    },
    validateUser() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.saveUser();
      }
    }
  }
};
</script>

<style scoped>
.amount-txt {
  text-align: center;
  font-size: 24px;
  color: black;
}
.confirm-btn {
  height: 50px;
  width: 40%;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-bottom: 8px;
  background-color: #889247 !important;
}

.margin-top {
  margin-top: 14px;
}

.margin-sides {
  margin-right: 2vw;
  margin-left: 2vw;
}

.pad-sides {
  padding-left: 48px;
  padding-right: 48px;
}

#divider {
  height: 32px;
}
.form {
  margin-top: 32px;
}
#title {
  top: 4vh;
  width: 100%;
  color: white;
  font-size: 48px;
}

.bg {
  background-image: url(https://storage.googleapis.com/tzav-rishon-web-assets/blurred_backpacks_bg.png);
  background-size: cover;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  position: absolute;
}
</style>